module.exports = __webpack_public_path__ + "assets/img/course_success.054c09cb.png";